// extracted by mini-css-extract-plugin
module.exports = {"reason-select__label":"ReasonSelect_reason-select__label__nqay9"};